<template>
    <div>
        <br />

        <div class="row text-center">
            <span class="p-2">
                Ajouter les informations de livraison à la commande Nº :
                <span class="fw-bold">
                    {{ $route.params.reference }}
                </span>
            </span>
        </div>
        <br />
        <div class="row">
            
            <div class="col-3 my-3">
                <label for="">Chauffeur</label>
                <vue-select :options="deliveries" v-model="order.delivery_reference" labelColumn="fullName"
                    valueColumn="reference" />
            </div>


            <div class="col-3 my-3">
                <label for=""> LP </label>
                <input type="text" v-model="order.passPermit" class="form-control">
            </div>

            <div class="col-12 my-3">
                <label for="">Remarque</label>
                <textarea class="form-control" v-model="order.remark"></textarea>
            </div>
        </div>


        <!-- <div class="row align-items-stretch">
            <div class="col-4">
                <div class="row justify-content-between">
                    <div class="col p-1">Client</div>
                    <div class="col p-1 fw-bold">
                        <span>
                            {{ order.customerFullName }}
                        </span>
                    </div>
                </div> 


            </div>
            <div class="col-4">


                <div class="row justify-content-between">
                    <div class="col p-1">Nº de Téléphone</div>
                    <div class="col p-1 fw-bold">
                        <span>
                            {{ order.customerPhone }}
                        </span>
                    </div>
                </div>


            </div>
            <div class="col-4">


                <div class="row justify-content-between">
                    <div class="col p-1">Nom Commercial (Société)</div>
                    <div class="col p-1 fw-bold">
                        <span>
                            {{ order.customerSociety }}
                        </span>
                    </div>
                </div>
            </div>
        </div> -->
        <vue-order-details :order="order" :reference="$route.params.reference" />

        <br />

        <vue-data-table v-if="order.orderItems" :headers="headers" :data="order.orderItems" :items-per-page="10">

            <template #cell-priceTTC="{ row }">
                <span class="px-2 py-1 rounded " v-show="$userRole != 'Magasinier'"
                    :class="row.priceTTC > 0 ? 'bg-light-primary text-primary' : 'bg-light-danger text-danger'">
                    {{ row.priceTTC }}
                </span>
            </template>


            <template #cell-totalPriceTTC="{ row }">
                <span class="px-2 py-1 rounded " v-show="$userRole != 'Magasinier'"
                    :class="row.totalPriceTTC > 0 ? 'bg-light-primary text-primary' : 'bg-light-danger text-danger'">
                    {{ row.totalPriceTTC }}
                </span>
            </template>

        </vue-data-table>
        <br />


        <button class="btn btn-success" @click="saveDelivery(order)">
            <i class="bi bi-check-square-fill"></i> Enregistrer
        </button>
        <br />
    </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
    data() {
        return { 
            headers: [
                { field: 'itemFullName', label: 'Désignation', class: '' },
                { field: 'priceTTC', label: 'Prix', class: 'fw-bold' },
                { field: 'quantity', label: 'Quantité', class: 'fw-bold' },
                { field: 'totalPriceTTC', label: ' Total ', class: 'fw-bold' },
                { field: 'userFullName', label: 'Créer par', class: '' },
            ],
        };
    },

    async beforeCreate() {
        await this.$store.dispatch("delivery/getAll");
        await this.$store.dispatch("order/show", this.$route.params.reference);
    },
    computed: {
        ...mapGetters("order", {
            order: "getOrder",
        }),

        ...mapGetters("delivery", {
            deliveries: "getAll",
        }),

       
    },
    methods: {
        async refresh() {
            await this.$store.dispatch("delivery/getAll");
            await this.$store.dispatch("order/show", this.$route.params.reference);
        },
        async saveDelivery(order) {
            await this.$store.dispatch("order/saveDelivery", order);
        },

    },
};
</script>
